export function roundHalfUp(value, digits = 2) {
    const unit = 10 ** digits
    return Math.round(Number((value * unit).toPrecision(15))) / unit
}
